var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return 0
    ? _c("v-progress-linear", {
        attrs: {
          active: _vm.isLoading,
          "background-opacity": 0,
          indeterminate: false,
          value: _vm.value,
          top: "",
          stream: "",
          query: "",
          height: "5",
          absolute: "",
          color: "primary",
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }